import {AbstractModel} from './abstract-model';

export class AsyncCommand extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  description: string | null = null;
  name: string | null = null;
  status: string | null = null;
  startedAt: Date | null = null;
  endedAt: Date | null = null;
  output: string | null = null;
  arguments: Object | null = null;
  options: Object | null = null;

  buildCommandLine(): string {
    let optionString = '';

    if (this.options) {
      for (const [key, value] of Object.entries(this.options)) {
        if (key === 'correlation-id' || key === 'env') {
          continue;
        }

        if (value === true) {
          optionString += ` --${key}`;
        } else if (value) {
          optionString += ` --${key}=${value}`;
        }
      }
    }

    return `${this.name ?? ''} ${Object.values(this.arguments ?? {})} ${optionString}`;
  }
}
